/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2024-08-06 16:27:55
 */
import { CloseCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import {
  Button,
  Form,
  Modal,
  Popconfirm, Popover,
  Space,
  Switch,
  TableColumnType,
} from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectInsuranceArray,
  selectTenantName,
} from '../../app/applicationSlice'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { BillingCategoryName } from '../../models/billingCategory'
import { getApproveFlgName, getChrgitmLvName } from '../../models/commodity'
import { Dimen } from '../../models/dimen'
import styles from './Examinetreat.module.css'
import { ColDef } from 'ag-grid-community'

export const Columns = (
  onClick: (id: number, text: string, t?: any) => void,
  startIndex: number,
  sortedInfo?: any
): TableColumnType<any>[] => {
  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantName = useSelector(selectTenantName)

  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '费用代码',
      align: 'center',
      dataIndex: 'no',
      width: Dimen.No,
      key: 'no',
    },
    {
      title: '项目名称',
      align: 'center',
      dataIndex: 'name',
      width: '14rem',
      ellipsis: true,
      key: 'name',
    },

    {
      title: '匹配状态',
      align: 'center',
      dataIndex: 'approveFlg',
      width: '8rem',
      ellipsis: true,
      key: 'approveFlg',
      className: insuranceArray.length == 0 ? 'notShow' : '',
      render: function Element(_, t) {
        return (
          <Button type={Number(t.approveFlg) ? 'link' : 'text'}>
            {getApproveFlgName(Number(t.approveFlg), t.rewriteHilistCode)}
          </Button>
        )
      },
    },
    {
      title: '医保国码',
      align: 'center',
      dataIndex: 'hilistCode',
      width: '22rem',
      ellipsis: true,
      className: insuranceArray.length == 0 ? 'notShow' : '',
      key: 'hilistCode',
      render: function Element(_, t) {
        return (
          <div className={t.hilistCode ? styles.delMedicalCode : ''}>
            <div
              className={styles.hilistName}
              onClick={() => {
                onClick(t.id, 'insurance', t)
              }}
            >
              {t.hilistCode && <div>{t.hilistName}</div>}
              <div>
                <Button type='link'>{t.hilistCode || '匹配'}</Button>
                {getChrgitmLvName(t.chrgitmLv)}
              </div>
            </div>

            {t.hilistCode && (
              <span className={styles.Close}>
                <CloseCircleOutlined
                  onClick={() => {
                    onClick(t.id, 'delCode', t)
                  }}
                />
              </span>
            )}
          </div>
        )
      },
      // render: function Element(_, t) {
      //   return (
      //     <Button
      //       type='link'
      //       onClick={() => {
      //         onClick('insurance', t.id, t)
      //       }}
      //     >
      //       查看
      //     </Button>
      //   )
      // },
    },
    {
      title: '医保限价',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: function Element(_, t) {
        const xj = Number(t.priceLimit || 0).toFixed(4)
        const isOverLimit = t.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t.retailPrice || 0).toFixed(5));
        return (
          isOverLimit ?
            <Popover
              content={
                <div>
                  <p>
                    零售价超医保限价！
                  </p>
                </div>
              }
              placement='top'
              title='注意'
            >
              <span style={{ color: 'red', fontWeight: "bold" }}>
                {Number(xj) > 0 && Number(xj) <= 99998
                  ? xj
                  : Number(xj) == -1
                    ? '-'
                    : '不限价'}
              </span>
            </Popover>
            :
            <span style={{ color: t.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
              {Number(xj) > 0 && Number(xj) <= 99998
                ? xj
                : Number(xj) == -1
                  ? '-'
                  : '不限价'}
            </span>
        )
      },
    },
    {
      title: '开票项目',
      align: 'center',
      width: Dimen.BillingCategory,
      ellipsis: true,
      dataIndex: 'billingCategory',
      key: 'billingCategory',
      render: (billingCategory: any) => {
        return BillingCategoryName(billingCategory)
      },
    },
    {
      title: '零售单价',
      align: 'right',
      dataIndex: 'retailPrice',
      width: Dimen.Price,
      ellipsis: true,
      key: 'retailPrice',
      render: (_, m) => m.retailPrice?.toFixed(2),
    },
    {
      title: '单位',
      align: 'center',
      dataIndex: 'accountUnit',
      width: Dimen.Unit,
      ellipsis: true,
      key: 'accountUnit',
    },
    {
      title: '排序',
      align: 'center',
      dataIndex: 'sortNo',
      width: Dimen.Unit,
      ellipsis: true,
      key: 'sortNo',
      render: (_, m) => m.sortNo > 0 ? m.sortNo : "",
    },

    {
      title: '创建时间',
      // fixed: "left",
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'createTime',
      key: 'createTime',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'createTime' && sortedInfo?.order,
    },
    {
      title: '最近一次修改',
      align: 'center',
      dataIndex: 'lastUpdateTime',
      width: '10rem',
      key: 'lastUpdateTime',
      ellipsis: true,
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'lastUpdateTime' && sortedInfo?.order,
      render: function Element(_, t) {
        return (
          <a onClick={(e) => {
            e.preventDefault()
            if (t?.lastUpdateTime) {
              onClick(t?.id, 'lastEditOperation', t)
            }
          }}
            style={{ cursor: 'pointer' }}
          >
            {t?.lastUpdateTime}
          </a>
        )
      }
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'state',
      width: Dimen.State,
      ellipsis: true,
      key: 'state',
      render: function Element(_, t) {
        return (<div style={{ height: '39px' }}>
          {t.state === 1 ? (
            <Popconfirm
              title={'确认进行注销操作吗？'}
              onConfirm={() => {
                onClick(t.id, 'loEforce', t)
              }}
              onCancel={() => {
                onClick(t.id, 'loE', t)
              }}
              okText='确认并同步删除套餐/未收费处方'
              //取消按钮当做注销，确认按钮当做强行注销
              cancelButtonProps={{
                style: {
                  border: 0,
                  backgroundColor: '#027AFF',
                  color: '#FFF',
                },
              }}
              okButtonProps={{
                style: {
                  border: 0,
                  backgroundColor: '#fe2121',
                  color: '#FFF',
                },
              }}
              cancelText='确认'
            >
              <a href='#'>
                <StateSwitch value={t.state === 1} />
              </a>
            </Popconfirm>
          ) : (
            <Popconfirm
              title={'确认进行启用操作？'}
              onConfirm={() => {
                onClick(t.id, 'loE', t)
              }}
              onCancel={() => {
                return
              }}
              okText='确认'
              cancelText='取消'
            >
              <a href='#'>
                <StateSwitch value={t.state === 1} />
              </a>
            </Popconfirm>
          )}
        </div>)


        // return (
        //   <Popconfirm
        //     title='确认进行此操作？'
        //     onConfirm={() => {
        //       onClick(t.id, 'loE', t)
        //     }}
        //     onCancel={() => {
        //       return
        //     }}
        //     okText='确认'
        //     cancelText='取消'
        //   >
        //     <a href='#'>
        //       <StateSwitch value={t.state === 1} />
        //     </a>
        //   </Popconfirm>
        //   // <StateSwitch
        //   //   value={t.state === 1}
        //   //   onChange={() => {
        //   //     onClick(t.id, "loE", t)
        //   //   }}
        //   // />
        // )
      },
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'id',
      key: 'id',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              type='primary'
              ghost
              size='small'
              style={{ marginRight: '6px' }}
              onClick={(e: any) => {
                onClick(t.id, 'edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              type='primary'
              ghost
              size='small'
              onClick={() => {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;您确定复制目录吗？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    onClick(t.id, 'copyCatalog', t)
                  },
                })
              }}
            >
              复制目录
            </Button>
          </>
        )
      },
    },
  ]

  const result =
    tenantName?.indexOf('余姚健齿口腔诊所有限公司') >= 0 ||
      tenantName?.indexOf('余姚康民内科诊所') >= 0 ||
      tenantName?.indexOf('宁波鄞州青木堂中医诊所') >= 0 ||
      tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') >= 0 ||
      tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') >= 0
      ? columns.filter((v) => v.key != 'approveFlg')
      : columns

  return result
}

export const AGColumns = (
  onClick: (id: number, text: string, t?: any) => void,
  startIndex?: any,
  columnList?: any,
): ColDef[] => {

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'no': //费用代码
        case 'name': //项目名称
        case 'accountUnit': //单位
        case 'createTime': // 创建时间
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val ? val : '';
            },
          };
        case 'approveFlg': // 匹配状态
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function getApproveFlg(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (
                <Button type={Number(t?.approveFlg) ? 'link' : 'text'}>
                  {getApproveFlgName(Number(t?.approveFlg), t?.rewriteHilistCode)}
                </Button>)
            },
          };
          // 税率
        case 'tax':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.taxStr != null && t?.taxStr !== '' ? t?.tax : '-'
            },
          };
        case 'hilistCode':  // 医保国码
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function gethilistCode(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (
                <div className={t.hilistCode ? styles.delMedicalCode : ''}>
                  <div
                    className={styles.hilistName}
                    onClick={() => {
                      onClick(t.id, 'insurance', t)
                    }}
                  >
                    {t.hilistCode && <div>{t.hilistName}</div>}
                    <div>
                      <Button type='link'>{t.hilistCode || '匹配'}</Button>
                      {getChrgitmLvName(t.chrgitmLv)}
                    </div>
                  </div>

                  {t.hilistCode && (
                    <span className={styles.Close}>
                      <CloseCircleOutlined
                        onClick={() => {
                          onClick(t.id, 'delCode', t)
                        }}
                      />
                    </span>
                  )}
                </div>
              )
            },
          };
        case 'priceLimit': // 医保限价
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function getApproveFlg(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const xj = Number(t?.priceLimit || 0).toFixed(4)
              const isOverLimit = t.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t.retailPrice || 0).toFixed(5));
              return (
                isOverLimit ?
                  <Popover
                    content={
                      <div>
                        <p>
                          零售价超医保限价！
                        </p>
                      </div>
                    }
                    placement='top'
                    title='注意'
                  >
                    <span style={{ color: 'red', fontWeight: "bold" }}>
                      {Number(xj) > 0 && Number(xj) <= 99998
                        ? xj
                        : Number(xj) == -1
                          ? '-'
                          : '不限价'}
                    </span>
                  </Popover>
                  :
                  <span style={{ color: t.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
                    {Number(xj) > 0 && Number(xj) <= 99998
                      ? xj
                      : Number(xj) == -1
                        ? '-'
                        : '不限价'}
                  </span>
              )
            },
          };
        case 'billingCategory': //开票项目
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return value ? BillingCategoryName(value) : '-';
            },
          };
        case 'retailPrice': // 零售单价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.retailPrice == -1 ? '-' : t.retailPrice
                ? parseFloat(t?.retailPrice).toFixed(2)
                : parseFloat('0').toFixed(2)
            },
          };
        case 'sortNo': //排序
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val > 0 ? val : '';
            },
          };
        case 'lastUpdateTime': // 最近一次修改
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function getlastUpdateTime(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (
                <a onClick={(e) => {
                  e.preventDefault()
                  if (t?.lastUpdateTime) {
                    onClick(t?.id, 'lastEditOperation', t)
                  }
                }}
                  style={{ cursor: 'pointer' }}
                >
                  {t?.lastUpdateTime}
                </a>
              )
            },
          };
        case 'state': // 状态
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function getState(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (<div style={{ height: '39px' }}>
                {t.state === 1 ? (
                  <Popconfirm
                    title={'确认进行注销操作吗？'}
                    onConfirm={() => {
                      onClick(t.id, 'loEforce', t)
                    }}
                    onCancel={() => {
                      onClick(t.id, 'loE', t)
                    }}
                    okText='确认并同步删除套餐/未收费处方'
                    //取消按钮当做注销，确认按钮当做强行注销
                    cancelButtonProps={{
                      style: {
                        border: 0,
                        backgroundColor: '#027AFF',
                        color: '#FFF',
                      },
                    }}
                    okButtonProps={{
                      style: {
                        border: 0,
                        backgroundColor: '#fe2121',
                        color: '#FFF',
                      },
                    }}
                    cancelText='确认'
                  >
                    <a href='#'>
                      <StateSwitch value={t.state === 1} />
                    </a>
                  </Popconfirm>
                ) : (
                  <Popconfirm
                    title={'确认进行启用操作？'}
                    onConfirm={() => {
                      onClick(t.id, 'loE', t)
                    }}
                    onCancel={() => {
                      return
                    }}
                    okText='确认'
                    cancelText='取消'
                  >
                    <a href='#'>
                      <StateSwitch value={t.state === 1} />
                    </a>
                  </Popconfirm>
                )}
              </div>)
            },
          };
        case 'action': // 状态
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function getAction(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (
                <>
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    style={{ marginRight: '6px' }}
                    onClick={(e: any) => {
                      onClick(t.id, 'edit', t)
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    onClick={() => {
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;您确定复制目录吗？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          onClick(t.id, 'copyCatalog', t)
                        },
                      })
                    }}
                  >
                    复制目录
                  </Button>
                </>
              )
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
          };
      }
    })
  )
}
